var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseLightFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 80,
    viewBox: "0 0 58 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 79V15.3344L42.4184 1H1.06897V79H57Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15.1724H42.8276V0L58 15.1724Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34321 15.1724H23.5156V17.931H8.34321V15.1724Z",
    fill: "#6F6FF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34726 24.8276H49.7266V27.5863H8.34726V24.8276Z",
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07031 34H39.0703V37H8.07031V34Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34726 44.1382H49.7266V46.8968H8.34726V44.1382Z",
    fill: "#D6D6D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07031 54H39.0703V57H8.07031V54Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34726 63.4487H49.7266V66.2074H8.34726V63.4487Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLightFile);
export default __webpack_public_path__ + "static/media/courseLightFile.110c1a078ec7542bd38ed4344ad02ac8.svg";
export { ForwardRef as ReactComponent };